import { Breadcrumbs, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title }) => {
    return (<>
        <div className={['rounded', 'pb-2'].join(" ")} style={{ marginTop: "-10px", direction: "rtl", background: "#f1f2f7" }}>
            <div style={{ background: "#fff" }} className="py-2  px-4">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link to="/admin" >
                        <small style={{color:"#00BAC6"}}>
                            پنل مدیریت
                        </small>
                    </Link>


                    <Typography color="textPrimary">
                        <small>{title} 
                        </small>
                        </Typography>
                </Breadcrumbs>
            </div>
        </div>
    </>)
}

export default Breadcrumb;